var _sortBy;

_sortBy = function(array, propName, isDesc) {
  array.sort(function(a, b) {
    var propA, propB;
    propA = ko.unwrap(a[propName]);
    propB = ko.unwrap(b[propName]);
    if ((propA != null) && (propB != null)) {
      if (propA > propB) {
        if (isDesc) {
          return -1;
        } else {
          return 1;
        }
      } else if (propA < propB) {
        if (isDesc) {
          return 1;
        } else {
          return -1;
        }
      } else {
        return 0;
      }
    } else {
      throw 'each item in the array must have the property you are sorting on';
    }
  });
  return array;
};

ko.filterableArray = function(initValues, options) {
  var result;
  options = $.extend({
    fields: ['name', 'description', 'id'],
    comparer: function(query, item) {
      var match;
      item = ko.unwrap(item);
      if (typeof query !== 'string') {
        throw 'The default comparer only supports string queries, you can provide your own comparer to support object queries';
      }
      query = query.toLowerCase();
      if (typeof item === 'string') {
        return item.toLowerCase().indexOf(query) > -1;
      } else if (typeof item === 'object') {
        match = false;
        options.fields.forEach(function(p) {
          if (item.hasOwnProperty(p) && options.comparer(query, item[p])) {
            return match = true;
          }
        });
        return match;
      } else {
        return query === item.toString();
      }
    }
  }, options);
  result = ko.pureComputed({
    read: function() {
      var query;
      if (result._sorter() != null) {
        result.all.sort(result._sorter());
      }
      if (result.query()) {
        query = result.query();
        return result.all().filter(function(value) {
          return options.comparer(query, value);
        });
      }
      return result.all();
    },
    write: function(value) {
      return result.all(value);
    }
  });
  result.all = ko.asObservableArray(initValues);
  result.query = ko.observable();
  result._sorter = ko.observable(null);
  result.isSorting = ko.pureComputed(function() {
    return result._sorter() != null;
  });
  result.clearSort = function() {
    return result._sorter(null);
  };
  result.isFilterableArray = true;
  result.length = 0;
  result.sortByString = function(propName) {
    return result._sorter(function(a, b) {
      var propA, propB;
      propA = ko.unwrap(a[propName]);
      propB = ko.unwrap(b[propName]);
      if ((propA != null) && (propB != null)) {
        if (propA > propB) {
          return 1;
        } else if (propA < propB) {
          return -1;
        } else {
          return 0;
        }
      } else {
        throw 'each item in the array must have the property you are sorting on';
      }
    });
  };
  result.sortByStringDesc = function(propName) {
    return result._sorter(function(a, b) {
      var propA, propB;
      propA = ko.unwrap(a[propName]);
      propB = ko.unwrap(b[propName]);
      if ((propA != null) && (propB != null)) {
        if (propA > propB) {
          return -1;
        } else if (propA < propB) {
          return 1;
        } else {
          return 0;
        }
      } else {
        throw 'each item in the array must have the property you are sorting on';
      }
    });
  };
  result.sort = function(func) {
    if (func != null) {
      return result._sorter(func);
    } else {
      throw 'you need to specify a sort function when using sort on a filterableArray';
    }
  };
  ['pop', 'push', 'reverse', 'shift', 'splice', 'unshift', 'slice', 'replace', 'indexOf', 'destroy', 'destroyAll', 'remove', 'removeAll'].forEach(function(method) {
    return result[method] = function() {
      return result.all[method].apply(result.all, arguments);
    };
  });
  return result;
};
